export default __webpack_public_path__ + "static/media/textLogoWhite.b3d4f24f.png";